import { useEffect } from "react";

const ClientifySpider = ({ spider_id }) => {
  const src = `https://api.clientify.net/web-marketing/webforms/external/script/${spider_id}.js`;
  const id = `clientify-spider-${spider_id}`;

  const insertSpider = () => {
    setTimeout(() => {
      if (document.getElementById(id)) {
        console.log(`ClientifySpider: Script ${id} already exists`);
        return;
      }

      console.log(`ClientifySpider: Loading script for spider_id: ${spider_id}`);
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = id;
      script.src = src;
      document.body.appendChild(script);

      script.onload = () => {
        console.log(`ClientifySpider: Script ${id} loaded successfully`);
        window.document.dispatchEvent(
          new Event("DOMContentLoaded", {
            bubbles: true,
            cancelable: true,
          })
        );
      };
    }, 0);
  };

  const removeSpider = () => {
    const script = document.getElementById(id);
    if (script) {
      script.remove();
      console.log("removed");
    }
  };

  useEffect(() => {
    insertSpider();
    return () => {
      removeSpider();
    };
  }, []);

  return null;
};

export default ClientifySpider;
